import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function EasyLoading_Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/EasyLoading" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            EasyLoading{" "}
          </span>
        </div>
      ) : vPathName === "/EasyLoadingDetail" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/EasyLoading"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            EasyLoading
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              EasyLoadingDetail{" "}
            </span>
          </div>
        </div>
      ) : vPathName === "/TripDetail" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Trip Detail{" "}
          </span>
        </div>
      ) : (
        <></>
      )} 
    </div>
  );
}
export default EasyLoading_Breadcrumbs;
